/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Favorite_AddInputs */

const en_us2_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to favourites`)
};

const pt_br2_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritar`)
};

const es_419_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar a favoritos`)
};

const pt_pt2_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar aos favoritos`)
};

const fr_fr2_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter aux favoris`)
};

const de_de2_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Favoriten`)
};

const it_it2_exercise_personal_favorite_add = /** @type {(inputs: Exercise_Personal_Favorite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi ai preferiti`)
};

/**
* | output |
* | --- |
* | "Add to favourites" |
*
* @param {Exercise_Personal_Favorite_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_favorite_add = /** @type {((inputs?: Exercise_Personal_Favorite_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Favorite_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_favorite_add(inputs)
	if (locale === "es-419") return es_419_exercise_personal_favorite_add(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_favorite_add(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_favorite_add(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_favorite_add(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_favorite_add(inputs)
	return en_us2_exercise_personal_favorite_add(inputs)
});
export { exercise_personal_favorite_add as "exercise-personal.favorite_add" }